// extracted by mini-css-extract-plugin
export default {"mainContainer":"AutoCompleteSearch_mainContainer__HKhsW","wrapper":"AutoCompleteSearch_wrapper__fJDrm","resultsContainer":"AutoCompleteSearch_resultsContainer__tdfH7"};